import { render, staticRenderFns } from "./organize_edit_m.vue?vue&type=template&id=450dd030&scoped=true&"
import script from "./organize_edit_m.vue?vue&type=script&lang=js&"
export * from "./organize_edit_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450dd030",
  null
  
)

export default component.exports